/**
 * Copia de la paleta de colores del avatar (fuente de verdad en backend:
 * `backend/src/modules/users/avatar-palette.ts`). Se duplica aquí para
 * pintar los swatches de selección en Ajustes sin una llamada extra al
 * API. Si cambias una lista, actualiza la otra.
 *
 * El primer color (azul Icaria) es el valor por defecto cuando el usuario
 * no ha elegido ninguno.
 */
export const AVATAR_PALETTE = [
  '#1B23B8', // azul Icaria (default)
  '#1F6B3E', // verde
  '#B91C1C', // rojo
  '#C2410C', // naranja
  '#A16207', // mostaza
  '#7E22CE', // púrpura
  '#BE185D', // fucsia
  '#EC4899', // rosa
  '#0E7490', // teal
  '#4338CA', // índigo
  '#475569', // pizarra
];

/** Color de fondo por defecto del avatar (azul Icaria). */
export const DEFAULT_AVATAR_COLOR = AVATAR_PALETTE[0];
